import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
    card: [],
    hourlyApplication: [],
    isLoadingHourlyApplication: true,
    hourlyApplicationChild: [],
    isLoadingHourlyApplicationChild: true,
    hourlyApplicationChildXLabels: [0,1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
    hourlyApplicationChildYLabels: [],
    hourlyApplicationChildYLabelsID: '',
    isLoadingApplicationCategory: true,
    applicationCategory: {
        head: [],
        body: []
    },
    topApplication: [],
    webCategory: {
        head: [],
        body: []
    },
    topWebsite: [],
    isLoadingWebCategory: true,
    timeSplitApp: {
        head: [],
        body: []
    },
    isLoadingTimeSplitApp: true,
    timeSplitWeb: {
        head: [],
        body: []
    },
    isLoadingTimeSplitWeb: true
}
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.SUCCESS_SYSTEM_RESOURCES_CARD:
            var data = [
                {
                    name: 'App Time Hrs',
                    unitBefore: action.data.totalAppTime.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "Clock",
                    background: 'rgba(87,113,219,0.05)'
                },
                {
                    name: 'Average Person App Hrs',
                    unitBefore: action.data.applicationHours.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "In",
                    background: 'rgba(87,113,219,0.05)'
                },
                {
                    name: 'Web Time Hrs',
                    unitBefore: action.data.totalWebTime.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "User",
                    background: 'rgba(87,113,219,0.05)'
                },
                {
                    name: 'Average Person Web Hrs',
                    unitBefore: action.data.webHours.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "Clock2",
                    background: 'rgba(87,113,219,0.05)'
                },

            ]
            return {
                ...state,
                card: data,
            }
        case types.SUCCESS_SYSTEM_RESOURCES_SINGLE_CARD:
            var data = [
                {
                    name: 'App Time Hrs',
                    unitBefore: action.data.totalAppTime.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "Clock",
                    background: 'rgba(87,113,219,0.05)'
                },
                {
                    name: 'Person App Hrs',
                    unitBefore: action.data.applicationHours.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "In",
                    background: 'rgba(87,113,219,0.05)'
                },
                {
                    name: 'Web Time Hrs',
                    unitBefore: action.data.totalWebTime.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "User",
                    background: 'rgba(87,113,219,0.05)'
                },
                {
                    name: 'Person Web Hrs',
                    unitBefore: action.data.webHours.replace(":", "."),
                    unitAfter: '',
                    size: 3,
                    icon: "Clock2",
                    background: 'rgba(87,113,219,0.05)'
                },

            ]
            return {
                ...state,
                card: data,
            }
        case types.SUCCESS_HOURLY_APPLICATION:
            if (action.data.length > 0) {
                var date = action.data.map((value, i) => {
                    return { id: value.dates, name: value.dates };
                });
                return {
                    ...state,
                    hourlyApplication: date,
                    isLoadingHourlyApplication: false
                }
            } else {
                return {
                    ...state,
                    hourlyApplication: [],
                    isLoadingHourlyApplicationChild: false,
                    isLoadingHourlyApplication: false
                }
            }
        case types.FAILED_HOURLY_APPLICATION:
            return {
                ...state,
                hourlyApplication: [],
                isLoadingHourlyApplication: false,
                isLoadingHourlyApplicationChild: false,
            }
        case types.SUCCESS_HOURLY_APPLICATION_CHILD:
            var array = action.data.getDataApplication.length != 0 ? action.data.getDataApplication.sort(function (i, b) {
                var k = (parseInt(i.hour0) + parseInt(i.hour1) + parseInt(i.hour2) + parseInt(i.hour3) + parseInt(i.hour4) + parseInt(i.hour5) + parseInt(i.hour6) + parseInt(i.hour7) + parseInt(i.hour8) + parseInt(i.hour9) + parseInt(i.hour10) + parseInt(i.hour11) + parseInt(i.hour12) + parseInt(i.hour13) + parseInt(i.hour14) + parseInt(i.hour15) + parseInt(i.hour16) + parseInt(i.hour17) + parseInt(i.hour18) + parseInt(i.hour19) + parseInt(i.hour20) + parseInt(i.hour21) + parseInt(i.hour22) + parseInt(i.hour23));
                var j = (parseInt(b.hour0) + parseInt(b.hour1) + parseInt(b.hour2) + parseInt(b.hour3) + parseInt(b.hour4) + parseInt(b.hour5) + parseInt(b.hour6) + parseInt(b.hour7) + parseInt(b.hour8) + parseInt(b.hour9) + parseInt(b.hour10) + parseInt(b.hour11) + parseInt(b.hour12) + parseInt(b.hour13) + parseInt(b.hour14) + parseInt(b.hour15) + parseInt(b.hour16) + parseInt(b.hour17) + parseInt(b.hour18) + parseInt(b.hour19) + parseInt(b.hour20) + parseInt(b.hour21) + parseInt(b.hour22) + parseInt(b.hour23));
                if (k > j) return 1;
                if (k < j) return -1;
                return 0;
            }).reverse() : []
            return {
                ...state,
                hourlyApplicationChild: array.map(i => {
                    return [i.hour0, i.hour1, i.hour2, i.hour3, i.hour4, i.hour5, i.hour6, i.hour7, i.hour8, i.hour9, i.hour10,
                    i.hour11, i.hour12, i.hour13, i.hour14, i.hour15, i.hour16, i.hour17, i.hour18, i.hour19, i.hour20, i.hour21, i.hour22, i.hour23]
                }),
                hourlyApplicationChildYLabels: array.map(i => {
                    return i.applicationname
                }),
                hourlyApplicationChildYLabelsID: array.map(i => {
                    return i.appId
                }),

                hourlyApplicationChart: action.data.getDataApplicationWiseDepartment,
                isLoadingHourlyApplicationChild: false,
            }
        case types.FAILED_HOURLY_APPLICATION_CHILD:
            return {
                ...state,
                hourlyApplicationChild: [],
                isLoadingHourlyApplicationChild: false,
            }
        case types.FETCH_HOURLY_APPLICATION_CHILD:
            return {
                ...state,
                isLoadingHourlyApplicationChild: true,
            }
        case types.SUCCESS_APPLICATION_LIST_CATEGORY:
            var data = action.data.map(i => {
                return [i.applicationCategory, i.time.replace(":", "."), i.percentage, {
                    id: i.categoryID,
                    isExpendable: false, child: action.child
                        .filter(item => item.categoryID == i.categoryID)
                        .map((value, index) => {
                            return [value.application, value.time.replace(":", "."), value.percentage]
                        })
                }]
            })
            return {
                ...state,
                applicationCategory: {
                    head: [
                        { label: "Category", align: "left" },
                        { label: "Work Hours", align: "right" },
                        { label: "Time Spent %", align: "right" },
                    ],
                    body: data
                },
                isLoadingApplicationCategory: false,
                topApplication: action.data.map(i => {
                    return {
                        name: i.applicationCategory, value: parseFloat(i.percentage)
                    }
                }),

            }
        case types.FAILED_APPLICATION_LIST_CATEGORY:
            return {
                ...state,
                applicationCategory: {
                    head: [],
                    body: []
                },
                isLoadingApplicationCategory: false
            }

        case types.SUCCESS_WEB_LIST_CATEGORY:

            var data = action.data.map(i => {
                return [i.applicationCategory, i.time.replace(":", "."), i.percentage, {
                    id: i.categoryID,
                    isExpendable: false, child: action.child
                        .filter(item => item.categoryID == i.categoryID)
                        .map((value, index) => {
                            return [value.application, value.time.replace(":", "."), value.percentage]
                        })
                }]
            })
            return {
                ...state,
                webCategory: {
                    head: [
                        { label: "Category", align: "left" },
                        { label: "Work Hours", align: "right" },
                        { label: "Time Spent %", align: "right" },
                    ],
                    body: data
                },
                topWebsite: action.data.map(i => {
                    return {
                        name: i.applicationCategory, value: parseFloat(i.percentage)
                    }
                }),
                isLoadingWebCategory: false

            }
        case types.FAILED_WEB_LIST_CATEGORY:
            return {
                ...state,
                webCategory: {
                    head: [],
                    body: []
                },
                isLoadingWebCategory: false
            }
        case types.SUCCESS_TIME_SPLIT_CATEGORY:

            var data = action.data.map(i => {
                return [i.application, i.totalTime, i.idleTime, i.productiveTime, i.totalPercentage, i.idlePercentage, i.productivePercentage, {
                    id: i.categoryID,
                    isExpendable: false, child: action.child
                        .filter(item => item.categoryID == i.categoryID)
                        .map((value, index) => {
                            return [value.application, value.totalTime, value.idleTime, value.productiveTime, value.totalPercentage, value.idlePercentage, value.productivePercentage]
                        })
                }]
            })
            return {
                ...state,
                timeSplitApp: {
                    head: [
                        { label: "Category", align: "left" },
                        { label: "Total Time", align: "right" },
                        { label: "Idle Time", align: "right" },
                        { label: "Productive Time", align: "right" },
                        { label: "Total %", align: "right" },
                        { label: "Idle %", align: "right" },
                        { label: "Productive %", align: "right" },
                    ],
                    body: data
                },
                isLoadingTimeSplitApp: false

            }
        case types.FAILED_TIME_SPLIT_CATEGORY:
            return {
                ...state,
                timeSplitApp: {
                    head: [],
                    body: []
                },
                isLoadingTimeSplitApp: false
            }
        case types.SUCCESS_WEB_TIME_SPLIT_CATEGORY:

            var data = action.data.map(i => {
                return [i.application, i.totalTime, i.idleTime, i.productiveTime, i.totalPercentage, i.idlePercentage, i.productivePercentage, {
                    id: i.categoryID,
                    isExpendable: false, child: action.child
                        .filter(item => item.categoryID == i.categoryID)
                        .map((value, index) => {
                            return [value.application, value.totalTime, value.idleTime, value.productiveTime, value.totalPercentage, value.idlePercentage, value.productivePercentage]
                        })
                }]
            })
            return {
                ...state,
                timeSplitWeb: {
                    head: [
                        { label: "Category", align: "left" },
                        { label: "Total Time", align: "right" },
                        { label: "Idle Time", align: "right" },
                        { label: "Productive Time", align: "right" },
                        { label: "Total %", align: "right" },
                        { label: "Idle %", align: "right" },
                        { label: "Productive %", align: "right" },
                    ],
                    body: data
                },
                isLoadingTimeSplitWeb: false

            }
        case types.FAILED_WEB_TIME_SPLIT_CATEGORY:
            return {
                ...state,
                timeSplitWeb: {
                    head: [],
                    body: []
                },
                isLoadingTimeSplitWeb: false
            }
        case types.SHOW_LOADER_SYSTEM_RESOURCE:
            return {
                ...state,
                card: [],
                hourlyApplication: [],
                isLoadingHourlyApplication: true,
                hourlyApplicationChild: [],
                isLoadingHourlyApplicationChild: true,
                hourlyApplicationChildXLabels: [0,1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
                hourlyApplicationChildYLabels: [],
                hourlyApplicationChildYLabelsID: '',
                isLoadingApplicationCategory: true,
                applicationCategory: {
                    head: [],
                    body: []
                },
                topApplication: [],
                webCategory: {
                    head: [],
                    body: []
                },
                topWebsite: [],
                isLoadingWebCategory: true,
                timeSplitApp: {
                    head: [],
                    body: []
                },
                isLoadingTimeSplitApp: true,
                timeSplitWeb: {
                    head: [],
                    body: []
                },
                isLoadingTimeSplitWeb: true
            }
        default:
            return state
    }
}
export default reducer
